/*
 * What the organiser has said about the event that the API does not carry
 * (../../docs/backend-gaps.md G18). The name, date, time and venue are NOT
 * here: they come from `GET /v1/sessions`, so a console edit reaches the page
 * without a deploy. When the backend serves these, this file goes.
 */
import type { Lang } from "@rekati/i18n";
import type { Dict } from "./i18n/en";
import dendiPhoto from "../assets/speakers/dendi.jpg";
import setiajiPhoto from "../assets/speakers/setiaji.jpg";

type Bilingual = Record<Lang, string>;

export interface Speaker {
  name: string;
  role: Bilingual;
  /** The organisation badge, a key under `speakers.orgs` in the i18n dictionaries. */
  organisation: keyof Dict["speakers"]["orgs"];
  /** A file under src/assets/speakers, or null while the photo is still to come. */
  photo: string | null;
}

export const SPEAKERS: Speaker[] = [
  {
    name: "Bapak Setiaji, S.T., M.Si.",
    role: { en: "Director of Technology and Information", id: "Direktur Teknologi dan Informasi" },
    organisation: "bpjs",
    photo: setiajiPhoto,
  },
  {
    name: "Dendi Zuckergates",
    role: { en: "Founder", id: "Founder" },
    organisation: "osi",
    photo: dendiPhoto,
  },
];

/** The theme line, as the organiser wrote it; `how_it_works` carries it too. */
export const THEME_LINE: Bilingual = {
  en: "Connecting Systems. Securing Data. Enabling Better Healthcare.",
  id: "Connecting Systems. Securing Data. Enabling Better Healthcare.",
};

export const ABOUT: Bilingual = {
  en: "Powering the Future of Healthcare is a seminar that brings together information technology professionals from hospitals to discuss the progress, the challenges and the readiness of the digital infrastructure behind an increasingly integrated healthcare ecosystem.",
  id: "Powering the Future of Healthcare merupakan seminar yang secara khusus mempertemukan para profesional teknologi informasi di lingkungan rumah sakit untuk membahas perkembangan, tantangan, dan kesiapan infrastruktur digital dalam mendukung ekosistem healthcare yang semakin terintegrasi.",
};

/** Words of ABOUT the reveal marks with the yellow highlighter. */
export const ABOUT_HIGHLIGHTS: Record<Lang, string[]> = {
  en: ["hospitals", "digital", "integrated"],
  id: ["rumah", "sakit", "digital", "terintegrasi"],
};

/** The doorprize is hidden for now (its perks card and About stat); true brings both back. */
export const SHOW_DOORPRIZE = false;

/** The titles are i18n strings: `perks.merchTitle` and `perks.prizeTitle`. */
export const PERKS: { body: Bilingual; icon: "gift" | "ticket" }[] = [
  {
    icon: "gift",
    body: {
      en: "For every attendee who checks in on the day.",
      id: "Untuk setiap peserta yang hadir di hari acara.",
    },
  },
  {
    icon: "ticket",
    body: { en: "Drawn among attendees in the room.", id: "Diundi untuk peserta yang hadir di ruangan." },
  },
];

/**
 * "For more information, contact Desta". The number is the organiser's to give
 * (docs/event.md item 8): while it is null the page names the person and
 * leaves the number out rather than printing a placeholder.
 */
export const CONTACT: { name: string; phone: string | null } = {
  name: "Desta",
  phone: null,
};

/** Shown only while the API has no schedule; never preferred over it. */
export const FALLBACK = {
  startsAt: "2026-10-29T01:00:00Z",
  endsAt: "2026-10-29T05:00:00Z",
  venueName: "Rama Shinta Hall",
  venueAddress: "Resinda Hotel Karawang",
};
